import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/functions';
import 'firebase/storage';
import 'firebase/analytics';

import { isProduction } from 'config/environment';
import firebaseConfig from 'config/firebase';

const RECIPES_COLLECTION = 'recipes';
const RECIPE_LIKES = 'recipe_likes';
const BOOKMARKED_RECIPES = 'bookmarked_recipes';
const RECIPES_PHOTOS_STORAGE = 'recipes_photos';
const RECIPES_COVER_PHOTO_NAME = 'cover_photo';

export const initFirebase = () => {
  firebase.initializeApp(firebaseConfig);

  firebase.analytics();
};

export const logError = (error) =>
  firebase.analytics().logEvent('exception', {
    error,
  });

export const FirebaseAuthentication = () => firebase.auth();

export const RecipesCollectionRef = () =>
  firebase.firestore().collection(RECIPES_COLLECTION);

export const RecipeLikesCollectionRef = () =>
  firebase.firestore().collection(RECIPE_LIKES);

export const BookmarkedRecipesCollectionRef = () =>
  firebase.firestore().collection(BOOKMARKED_RECIPES);

export const RecipesPhotosStorage = (recipeID) => {
  if (!recipeID) throw new Error('recipeID cannot be empty');

  return firebase.storage().ref().child(RECIPES_PHOTOS_STORAGE).child(recipeID);
};

export const RecipesCoverPhotoStorageRefFromURL = (url) => {
  if (!url) throw new Error('url cannot be empty');

  return firebase.storage().refFromURL(url);
};

export const recipeCoverPhotoName = (mimeType) =>
  `${RECIPES_COVER_PHOTO_NAME}.${mimeType.slice(6)}`;

const FirebaseFunctions = () => {
  const firebaseFunctions = firebase.functions();

  if (!isProduction) firebaseFunctions.useEmulator('localhost', 5001);

  return firebaseFunctions;
};

export const bookmarkRecipeFunction = async (
  params = { recipeID: '', bookmarked: true }
) => {
  const func = FirebaseFunctions().httpsCallable('bookmarkRecipe-call');
  return await func(params);
};

export const createRecipeFunction = async (params = { recipe: {} }) => {
  const func = FirebaseFunctions().httpsCallable('createRecipe-call');
  return await func(params);
};

export const createUserFunction = async (
  params = { email: '', password: '', firstName: '', lastName: '' }
) => {
  const func = FirebaseFunctions().httpsCallable('createUser-call');
  return await func(params);
};

export const edtiRecipeFunction = async (
  params = { recipeContent: {}, recipeID: '' }
) => {
  const func = FirebaseFunctions().httpsCallable('editRecipe-call');
  return await func(params);
};

export const likeRecipeFunction = async (
  params = { recipeID: '', liked: true }
) => {
  const func = FirebaseFunctions().httpsCallable('likeRecipe-call');
  return await func(params);
};
